export default __webpack_public_path__ + "static/media/zoom-people.0d4bcd59.svg";